import { render, staticRenderFns } from "./solutionDetails8.vue?vue&type=template&id=40e928ee&scoped=true&"
import script from "./solutionDetails8.vue?vue&type=script&lang=js&"
export * from "./solutionDetails8.vue?vue&type=script&lang=js&"
import style0 from "./solutionDetails8.vue?vue&type=style&index=0&id=40e928ee&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e928ee",
  null
  
)

export default component.exports